import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import CropImageListImagesScreen from "./CropImageListImagesScreen";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function CropImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Trim & Crop Images Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/crop_image", title: "Crop Image Online" },
    data2: { link: "/crop_image", title: "Image Cropper Free" },
    data3: { link: "/crop_image", title: "Trim Images Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Crop images online easily. Trim photos, cut images, and adjust dimensions quickly with our fast, secure, and easy-to-use image crop tool."
      ></meta>
      <meta
        name="keywords"
        content="crop image, crop images online, image cropper, crop photo, photo cropper, cut image online, trim image, image cropping tool, online image cropper, crop pictures, image editor online, crop image free, adjust image size, crop image tool, photo editing online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CropImageListImagesScreen title={title}></CropImageListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our crop image website makes it easy to edit photos by removing unwanted areas and focusing on what matters most. With a powerful crop image online tool, users can quickly adjust image dimensions, improve composition, and prepare photos for websites, social media, documents, and presentations. This online image cropper allows you to precisely crop images without installing heavy software, making it ideal for beginners, professionals, and everyday users. Whether you want to trim image online for profile pictures, resize product photos for e-commerce, or adjust visuals for marketing creatives, a crop image tool delivers fast and accurate results. Modern image cropping tools support popular formats like JPG, PNG, and WebP while preserving original image quality. Using a crop image online solution saves time, works across devices, and ensures privacy by processing images securely. From designers and content creators to students and businesses, an online image cropper is an essential photo editing solution for clean, professional, and perfectly sized images." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Crop",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Crop Image Tool"
            why_use={[
              {
                title: "Remove Unwanted Areas from Images",
                description:
                  "Our crop image tool helps remove unnecessary parts of photos to focus on the main subject. Using crop image online or an image cropper improves clarity and visual appeal.",
              },
              {
                title: "Improve Image Composition and Framing",
                description:
                  "Cropping images allows better framing and balance, making photos look more professional for websites, blogs, and social media using a crop image online tool.",
              },
              {
                title: "Perfect for Social Media and Profile Photos",
                description:
                  "Our image cropper makes it easy to trim image online for profile pictures, cover photos, and posts that meet platform size requirements.",
              },
              {
                title: "Prepare Images for Websites and SEO",
                description:
                  "Using a crop image online tool helps optimize images for faster loading and better layout, improving user experience and SEO performance.",
              },
              {
                title: "Quick and Easy Image Editing",
                description:
                  "Our crop image tool allows instant editing without complex software, making image cropping fast, simple, and beginner-friendly.",
              },
              {
                title: "Resize and Trim Images for Any Use Case",
                description:
                  "With an image cropper, users can trim image online for documents, presentations, e-commerce product photos, and marketing materials.",
              },
              {
                title: "Maintain Image Quality While Cropping",
                description:
                  "Modern crop image online tools preserve resolution and clarity, ensuring high-quality results even after trimming images.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Our online image cropper supports JPG, PNG, WebP, and other popular formats, making it easy to crop images of any type.",
              },
              {
                title: "Works Across Devices Without Installation",
                description:
                  "Crop image online tools work on desktop and mobile browsers without downloads, offering flexibility and convenience.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I crop images online for free?",
                description:
                  "Open Shivapdf's image cropping tool, select an image from your device, adjust the crop area, and save the cropped image. You can crop supported images directly in your browser without installing additional software."
              },
              {
                title: "Can I crop images without uploading them?",
                description:
                  "Yes, Shivapdf processes supported images locally in your browser, allowing you to crop images without uploading their contents to a remote server. Your images remain on your device during local processing."
              },
              {
                title: "Can I crop images offline?",
                description:
                  "You may need an internet connection to open the Shivapdf website initially. If the image cropping tool and its required resources are available locally, you can crop images without an active internet connection."
              },
              {
                title: "Is this image cropping tool free to use?",
                description:
                  "Yes, you can use Shivapdf's image cropping tool for free, subject to any usage limits displayed on the website."
              },
              {
                title: "Are my images safe when cropping locally?",
                description:
                  "Local image cropping helps protect your privacy because image contents are processed on your device rather than uploaded to a remote server. For sensitive images, verify the tool's local processing behavior and review the website's privacy policy."
              },
              {
                title: "Do I need to install software to crop images?",
                description:
                  "No, you can crop supported images directly in your web browser using Shivapdf. There is no need to install a separate image editor or desktop application."
              },
              {
                title: "Which image formats can I crop?",
                description:
                  "Supported image formats depend on your browser and the cropping tool. Check the tool's upload area for compatible formats, which may include JPEG, JPG, PNG, and WebP."
              },
              {
                title: "Can I crop images on my phone?",
                description:
                  "Yes, you can use the image cropping tool in a supported browser on your iPhone, Android phone, or tablet. The interface lets you select an image, adjust the crop area, and save the result."
              },
              {
                title: "Can I crop images to a specific size?",
                description:
                  "If supported by the tool, you can set the desired crop dimensions or adjust the selection area to match your requirements. This is useful for profile pictures, social media posts, thumbnails, and other image formats."
              },
              {
                title: "Can I crop an image to a square?",
                description:
                  "Yes, select a square crop area to create a 1:1 image. Square crops are useful for profile pictures, avatars, product photos, and social media thumbnails."
              },
              {
                title: "Can I crop an image without losing quality?",
                description:
                  "Cropping removes unwanted portions of an image without necessarily reducing the quality of the remaining pixels. The final image quality also depends on the output format, resizing, and compression settings."
              },
              {
                title: "Can I crop images without creating an account?",
                description:
                  "You can use the cropping tool without creating an account if registration is not required by the website. Check the tool page for any applicable usage restrictions."
              },
              {
                title: "Will cropping change my original image?",
                description:
                  "The tool creates a cropped output image that you can save separately. Your original image remains unchanged unless you choose to overwrite it yourself."
              },
              {
                title: "Can I crop images without uploading them to a server?",
                description:
                  "Yes, when using Shivapdf's local image processing workflow, cropping happens directly in your browser. Your image contents do not need to be transmitted to a server to complete the crop."
              },
              {
                title: "Can I crop images for social media?",
                description:
                  "Yes, cropping can help prepare images for social media profiles, posts, stories, banners, and thumbnails. Choose the appropriate aspect ratio or dimensions if the tool supports them."
              },
              {
                title: "Can I crop multiple images at once?",
                description:
                  "Batch cropping depends on the features supported by the tool. If multiple-image processing is available, you can select several images and apply the supported cropping options."
              },
              {
                title: "Why should I use a local image cropping tool?",
                description:
                  "A local image cropping tool lets you edit images directly in your browser while keeping their contents on your device. It also avoids the need to upload large image files or install separate editing software."
              },
              {
                title: "How do I download a cropped image?",
                description:
                  "After adjusting the crop area, select the crop or save option to process your image. Then use the download option to save the cropped image to your device."
              }
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1071677375}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default CropImagesMain;
